 import request from './index'

 
 // 添加埋点记录
 export const addBuriedPoint = (data) =>{
     return request({
         method:'post',
         url:'api/marketing/mktCombatTouch/anyTenant/addTouchRecord',
         data:data
     })
 }
 // 提交问卷
 export const addQuestionnaire = (data) =>{
     return request({
         method:'post',
         url:'api/marketing/questionnaire/anyTenant/add',
         data:data
     })
 }
 


// WEBPACK FOOTER //
// ./src/api/api.js